import { GeoLocation, PagedFilter } from '../../common/common.types';

export enum EventQuestionType {
	Tag = 0,
	GeoRadius = 1,
	AttendeeRange = 2,
	EventVertical = 3,
	EventType = 4
}

export class EventQuestionFilter extends PagedFilter {
	isDefaultQuestion?: boolean;
	type?: EventQuestionType;
	searchTerm?: string;
}

export class EventQuestion {
	eventQuestionId: number;

	isDefaultQuestion: boolean;
	type: EventQuestionType;
	label: string;
	question: string;

	answers: EventAnswer[];
}

export class EventAnswer {
	eventAnswerId: number;

	label: string;
	value: EventAnswerValue;
	position: number;

	nextQuestion: NextEventQuestion;
}

export class EventAnswerValue {
	// EventQuestionType.Tag
	tags?: {
		[tag: string]: number;
	};

	// EventQuestionType.EventVertical
	eventVerticalId?: number;

	// EventQuestionType.EventType
	eventTypeId?: number;

	// EventQuestionType.AttendeeRange
	minAttendees?: number;
	maxAttendees?: number;

	// EventQuestionType.GeoRadius
	location?: GeoLocation;
	radiusInMetres?: number;
}

export class NextEventQuestion {
	eventQuestionId: number;
	type: EventQuestionType;
	question: string;
}

export class EventQuestionWM {
	isDefaultQuestion: boolean;
	type: EventQuestionType;
	label: string;
	question: string;

	answers: EventAnswerWM[];
}

export class EventAnswerWM {
	eventAnswerId?: number;
	label: string;
	value: EventAnswerValue;
	position: number;

	nextQuestionId?: number;
}
